import gql from "graphql-tag";

export const ADD_CARD_TO_TANGO = gql`
  mutation ($input: newTangoCardDetails) {
    addCardToTangoAccount(input: $input)
  }
`;
